export const iconsByVehicleVariant = {
    e4c: 'rioglyph rioglyph-bus',
    nhmr: 'rioglyph rioglyph-truck',
    tgx: 'rioglyph rioglyph-truck',
    ican: 'rioglyph rioglyph-truck',
    vw: 'rioglyph rioglyph-truck',
    fms: 'rioglyph rioglyph-van',
    other: 'rioglyph rioglyph-warning-sign',
    delivery: 'rioglyph rioglyph-delivery',
    core: 'rioglyph rioglyph-truck',
    elsa: 'rioglyph rioglyph-bus',
    true: 'rioglyph rioglyph-bus',
    unknown: 'rioglyph rioglyph-truck'
};
